import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FinancialPlanWarning from '../FinancialPlanWarning/FinancialPlanWarningContainer';
import PlanNotStarted from '../CommonComponents/PlanNotStarted';
import MissingInfo from '../ErrorPages/MissingInfoView';
import { ScrollHereOnce } from '../CommonComponents/ScrollHereOnce';
import { FINANCIAL_GOAL_TYPE_DICTIONARY } from './FinancialPlanComponentMap';
import { Alert } from '../CommonComponents/Alert/Alert';

export default class FinancialPlanView extends Component {
  static load({ fpId, clientId, fetchData }, event) {
    fetchData(fpId, clientId, event);
  }

  constructor(props) {
    super(props);
    this.financialPlanUpdate = this.financialPlanUpdate.bind(this);
  }

  UNSAFE_componentWillMount() {
    const {
      clientId,
      routeGoalId,
      setGoalId,
      getConsumerApplicationVariables,
      isConsumerArea,
      consumerApplicationVariablesLoaded,
      routeSubGoalTypeId,
      setSubGoalType,
    } = this.props;
    document.addEventListener('refreshFinancialPlan', this.financialPlanUpdate);
    FinancialPlanView.load(this.props);
    if (routeGoalId) {
      setGoalId(routeGoalId, clientId);
    }

    if (routeSubGoalTypeId) {
      setSubGoalType(parseInt(routeSubGoalTypeId, 10), clientId);
    }

    const { params: routeParams } = ADV.util.Router.getObjFromHash(ADV.util.getHash());
    if (isConsumerArea && routeParams.workflowEnded && !consumerApplicationVariablesLoaded) {
      getConsumerApplicationVariables(clientId, routeParams.workflowEnded);
    }
  }

  componentDidMount() {
    const {
      clientId,
      useWhatIfsSidebar,
      setWhatIfsVisible,
      selectedGoal: { GoalName },
      portalName,
    } = this.props;

    document.title = `Goals - ${GoalName} | ${portalName}`;
    setWhatIfsVisible(clientId, useWhatIfsSidebar);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { clientId, fpId, routeGoalId, setGoalId, setWhatIfsVisible } = this.props;

    if (clientId !== newProps.clientId) {
      setWhatIfsVisible(clientId, false);
      setWhatIfsVisible(newProps.clientId, true);
    }

    const shouldReload = newProps.clientId !== clientId || newProps.fpId !== fpId;

    if (shouldReload) {
      FinancialPlanView.load(newProps);
    }

    if (newProps.routeGoalId !== routeGoalId) {
      setGoalId(routeGoalId, clientId);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      selectedGoal: { GoalName },
      portalName,
    } = this.props;

    if (GoalName !== prevProps.selectedGoal.GoalName) {
      document.title = `Goals - ${GoalName} | ${portalName}`;
    }
  }

  componentWillUnmount() {
    const {
      clientId,
      resetData,
      setWhatIfsVisible,
      clearGoalsSummary,
      clearFinancialPlanData,
    } = this.props;
    resetData(clientId);
    document.removeEventListener('refreshFinancialPlan', this.financialPlanUpdate);
    setWhatIfsVisible(clientId, false);
    clearFinancialPlanData(clientId);
    clearGoalsSummary();
  }

  financialPlanUpdate(event) {
    FinancialPlanView.load(this.props, event);
  }

  render() {
    const { clientId, selectedGoal, errorType, errors, fetchData, fpId } = this.props;
    if (errors && errors.length > 0 && errorType === null) {
      return <Alert message={errors} />;
    }

    switch (errorType) {
      case 'PlanNotStarted':
        return <PlanNotStarted clientId={clientId} />;
      case 'MissingInfo':
        return <MissingInfo clientId={clientId} errors={errors} />;
      default:
        break;
    }

    const { GoalType, GoalName } = selectedGoal;

    let Content;

    if (
      selectedGoal.GoalType &&
      Object.prototype.hasOwnProperty.call(FINANCIAL_GOAL_TYPE_DICTIONARY, selectedGoal.GoalType)
    ) {
      Content = FINANCIAL_GOAL_TYPE_DICTIONARY[selectedGoal.GoalType];
    }

    if (!GoalType) {
      return null;
    }

    return (
      <div className="NewFinancialPlan">
        {/* Using boolean param as options to support IE11 */}
        <ScrollHereOnce key={`${GoalType}-${GoalName}` || 'summary'} options={false} />

        <FinancialPlanWarning clientId={clientId} />
        {!Content && <div className="FinancialPlanModule" />}
        {Content && (
          <div className="FinancialPlanModule">
            <Content {...this.props} refreshFinancialPlan={() => fetchData(fpId, clientId)} />
          </div>
        )}
      </div>
    );
  }
}

FinancialPlanView.defaultProps = {
  routeGoalId: null,
  errorType: null,
  setSubGoalType: null,
  routeSubGoalTypeId: undefined,
};

FinancialPlanView.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  errorType: PropTypes.string,
  clientId: PropTypes.string.isRequired,
  routeGoalId: PropTypes.string,
  fpId: PropTypes.string.isRequired,
  setGoalId: PropTypes.func.isRequired,
  selectedGoal: PropTypes.shape({
    GoalId: PropTypes.string.isRequired,
    GoalType: PropTypes.string,
    GoalName: PropTypes.string,
  }).isRequired,
  setWhatIfsVisible: PropTypes.func.isRequired,
  resetData: PropTypes.func.isRequired,
  clearGoalsSummary: PropTypes.func.isRequired,
  clearFinancialPlanData: PropTypes.func.isRequired,
  getConsumerApplicationVariables: PropTypes.func.isRequired,
  consumerApplicationVariablesLoaded: PropTypes.bool.isRequired,
  setSubGoalType: PropTypes.func,
  portalName: PropTypes.string.isRequired,
  isConsumerArea: PropTypes.bool.isRequired,
  routeSubGoalTypeId: PropTypes.string,
  useWhatIfsSidebar: PropTypes.bool.isRequired,
  fetchData: PropTypes.func.isRequired,
};
